import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { Modal } from '@garnish/overlays';

import { StripeCustomerSheet } from '@order/integrations-stripe';

export const PaymentMethodEditor = (props: PaymentMethodEditorProps) => {
  const { visible, onClose } = props;
  const { formatMessage } = useIntl();

  return (
    <Modal
      fitHeight
      size="small"
      visible={visible}
      accessibilityLabel={formatMessage(messages.a11yLabel)}
      onRequestClose={onClose}
    >
      <View style={styles.container}>
        <Modal.CloseBtn onPress={onClose} />

        <StripeCustomerSheet visible={visible} onClose={onClose} />
      </View>
    </Modal>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  a11yLabel: {
    defaultMessage: 'Manage payment methods',
    description: 'Payment method editor | Modal Headline',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: theme.spacing['4'],
    paddingBottom: theme.spacing['2'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type PaymentMethodEditorProps = {
  visible: boolean;
  onClose: () => void;
};
